import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiError } from '@cms_root/app/core/models/api-error.model';
import { ErrorBaseInterceptor } from '../../base/interceptors/error-base.interceptor';

@Injectable()
export class ForbiddenInterceptor extends ErrorBaseInterceptor {
  protected statusCode = 403;

  constructor(private readonly router: Router) {
    super();
  }

  protected handleError(error: ApiError): void {
    this.router.navigateByUrl('/403', { state: { error } });
  }
}
